import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-laguna',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './laguna.html',
  styleUrl: './laguna.css'
})
export class LagunaComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/laguna');
  }
}
